import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { isPriceFilterEnabledSelector } from 'common/selectors/theme';
import {
  getFiltersMenuIsOpenSelector,
  getThemeConfigSelector
} from 'common/selectors';
import { getPageDataSelector } from 'common/selectors/page';
import {
  addPageFilterResolve,
  filterPageProducts,
  togglePageModal
} from 'common/actions/PageActions';
import { toggleFilters } from 'common/actions/AppActions';

import Price from 'common/components/category/filters/_default/Price';
import AdvanceParameters from 'common/components/category/filters/_default/AdvanceParameters';
import SingleFilter from 'common/components/category/filters/_default/Single';
import ParametersFilter from 'common/components/category/filters/_default/Parameters';

import ButtonOutline from 'common/components/styleguide/ButtonOutline';
import Button from 'common/components/styleguide/Button';

import { withCssUnit } from 'common/components/styleguide/utils';
import { capfl, orderFilterData } from 'common/utils';


const DEFAULT_FILTERS_BACKGROUND = '#fff';

const S = {};

S.Filters = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) =>
    _.get(theme, 'filters.background', DEFAULT_FILTERS_BACKGROUND)};
  padding: ${({ theme }) => _.get(theme, 'filters.padding')};
  z-index: ${({ theme }) => _.get(theme, 'zIndex.filters')};
  overflow: auto;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: block;
    position: initial;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
    z-index: auto;
    background: ${({ theme }) =>
      _.get(theme, 'filters.backgroundMD', DEFAULT_FILTERS_BACKGROUND)};
    box-shadow: ${({ theme }) => _.get(theme, 'filters.boxShadow')};
    padding: ${({ theme }) => _.get(theme, 'filters.paddingMD')};
  }
`;

S.ToggleButtonXSWrapper = styled.div`
  margin-bottom: 40px;
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: none;
  }
`;

S.ToggleButtonXS = styled(Button)`
  && {
    width: 100%;
  }
`;

S.ButtonToggleAdvanceFilters = styled(ButtonOutline)`
  && {
    margin-top: 20px;
    border-radius: 0;
    display: none;
    @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
      display: flex;
    }
  }
`;

class Filters extends PureComponent {
  onShowFilterModalClick = e => {
    e.preventDefault();
    const { showFiltersModal } = this.props;
    showFiltersModal();
  };
  onToggleFiltersMenuClick = e => {
    e.preventDefault();
    const { toggleFiltersMenu } = this.props;
    toggleFiltersMenu();
  };
  render() {
    const {
      t,
      config,
      filter,
      activeFilters,
      addFilterResolve,
      submitFilters,
      filtersMenuIsOpen = false,
      isPriceFilterEnabled = true
    } = this.props;
    if (!_.isEmpty(filter)) {
      const parametersFiltersGroups = filter.parameters
        ? _.groupBy(filter.parameters, 'filter')
        : null;
      return (
        <S.Filters isOpen={filtersMenuIsOpen}>
          <S.ToggleButtonXSWrapper>
            <S.ToggleButtonXS onClick={this.onToggleFiltersMenuClick}>
              {capfl(t('close filter'))}
            </S.ToggleButtonXS>
          </S.ToggleButtonXSWrapper>
          {_.get(config, 'filters.price.active', true) &&
          isPriceFilterEnabled ? (
            <Price
              filterTitle="price"
              filterName="price"
              data={{
                minPrice: _.get(filter, 'minPrice'),
                maxPrice: _.get(filter, 'maxPrice'),
                selectedPriceFrom: _.get(filter, 'selectedPriceFrom'),
                selectedPriceTo: _.get(filter, 'selectedPriceTo')
              }}
              submitFilters={submitFilters}
              activeFilters={activeFilters}
              addFilterResolve={addFilterResolve('priceRange', t('price'))}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.brand.active', true) ? (
            <SingleFilter
              filterTitle="brands"
              filterName="brand"
              data={orderFilterData(
                filter.brands,
                _.get(config, 'filters.brand', null)
              )}
              submitFilters={submitFilters}
              activeFilters={activeFilters}
              addFilterResolve={addFilterResolve('brand', {
                resolvedName: t('brand'),
                resolvedFilterName: 'brands',
                resolvedLabelKey: 'v2-label',
                resolvedValueKey: 'v2-value'
              })}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.condition.active', true) ? (
            <SingleFilter
              filterTitle="conditions"
              filterName="condition"
              data={orderFilterData(
                filter.conditions,
                _.get(config, 'filters.condition', null)
              )}
              submitFilters={submitFilters}
              activeFilters={activeFilters}
              addFilterResolve={addFilterResolve('condition', t('condition'))}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.store.active', true) ? (
            <SingleFilter
              filterTitle="size"
              filterName="store"
              data={orderFilterData(
                filter.stores,
                _.get(config, 'filters.store', null)
              )}
              submitFilters={submitFilters}
              activeFilters={activeFilters}
              addFilterResolve={addFilterResolve('store', t('size'))}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.status.active', true) ? (
            <SingleFilter
              filterTitle="statuses"
              filterName="status"
              data={orderFilterData(
                filter.statuses,
                _.get(config, 'filters.status', null)
              )}
              submitFilters={submitFilters}
              activeFilters={activeFilters}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.storeLocation', true) ? (
            <SingleFilter
              filterTitle="store location"
              filterName="storeLocation"
              data={orderFilterData(
                filter.storeLocations,
                _.get(config, 'filters.storeLocation', null)
              )}
              submitFilters={submitFilters}
              activeFilters={activeFilters}
              addFilterResolve={addFilterResolve(
                'storeLocation',
                t('store location')
              )}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.parameters', true) ? (
            <ParametersFilter
              data={
                parametersFiltersGroups[1] ? parametersFiltersGroups[1] : null
              }
              submitFilters={submitFilters}
              activeFilters={activeFilters}
              addFilterResolve={addFilterResolve}
            />
          ) : (
            ''
          )}
          {_.get(config, 'filters.advanceParameters', true) &&
          parametersFiltersGroups[2] ? (
            <div>
              <S.ButtonToggleAdvanceFilters
                href="#"
                onClick={this.onShowFilterModalClick}
                buttonSize="small"
              >
                {capfl(t('show more'))}...
              </S.ButtonToggleAdvanceFilters>
              <AdvanceParameters
                data={
                  parametersFiltersGroups[2] ? parametersFiltersGroups[2] : null
                }
                submitFilters={submitFilters}
                activeFilters={activeFilters}
                addFilterResolve={addFilterResolve}
              />
            </div>
          ) : (
            ''
          )}
        </S.Filters>
      );
    }
    return null;
  }
}

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const getFiltersMenuIsOpen = getFiltersMenuIsOpenSelector();
  const getThemeConfig = getThemeConfigSelector();
  const isPriceFilterEnabled = isPriceFilterEnabledSelector();
  return (state, props) => {
    return {
      isPriceFilterEnabled: isPriceFilterEnabled(state, props),
      filtersMenuIsOpen: getFiltersMenuIsOpen(state, props),
      config: getThemeConfig(state, props),
      filter: _.get(getPageData(state, props), 'filter'),
      activeFilters: _.get(getPageData(state, props), 'activeFilters')
    };
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    submitFilters: async filters => {
      const { history } = props;
      dispatch(filterPageProducts({ newFilters: filters, history }));
    },
    addFilterResolve: (name, resolveName) => () => {
      dispatch(addPageFilterResolve(name, resolveName));
    },
    toggleFiltersMenu: () => {
      dispatch(toggleFilters());
    },
    showFiltersModal: () => {
      dispatch(togglePageModal('filters_parameters_advance', true));
    }
  };
};

const FiltersConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(Filters);

export default withTranslation()(withRouter(FiltersConnected));
